import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { H3 } from 'foundations-components/transitional/components/H3';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { Text } from 'foundations-components/components/Text';
import { PortalMessage, usePortalTranslations } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const fallbackFor = key => `(no translation saved for ${key})`;
export function TranslationsExample() {
  var _portalText;
  const {
    portalText,
    loading
  } = usePortalTranslations();
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: "Translations Example"
    }), /*#__PURE__*/_jsxs(Paragraph, {
      children: ["Renders the home space's portal translation keys using the Portal Translations primitives from portals-platform-lib. Each card shows a key rendered two ways: the ", /*#__PURE__*/_jsx("code", {
        children: "PortalMessage"
      }), " component and the", ' ', /*#__PURE__*/_jsx("code", {
        children: "usePortalTranslations"
      }), " hook. If no value has been saved for a key on the current portal instance, the fallback is shown instead."]
    }), /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [/*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-300",
            children: /*#__PURE__*/_jsx("code", {
              children: "HOME_SPACE_DISPLAY_NAME"
            })
          })
        }), /*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-400",
            children: "PortalMessage component"
          })
        }), /*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(PortalMessage, {
            messageKey: "HOME_SPACE_DISPLAY_NAME",
            fallback: fallbackFor('HOME_SPACE_DISPLAY_NAME')
          })
        }), /*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-400",
            children: "usePortalTranslations hook"
          })
        }), /*#__PURE__*/_jsx(Paragraph, {
          children: loading ? 'Loading translations…' : (_portalText = portalText('HOME_SPACE_DISPLAY_NAME')) !== null && _portalText !== void 0 ? _portalText : fallbackFor('HOME_SPACE_DISPLAY_NAME')
        })]
      })
    })]
  });
}